import classNames from "classnames";
import { PatternFormat } from "react-number-format";

import AscTextInput, {
  AscTextInputProps,
} from "../AscInputFields/AscTextInput/AscTextInput";
import styles from "./AscInputFormat.module.scss";

export interface AscInputFormatProps
  extends Omit<AscTextInputProps, "ref" | "value"> {
  value: string | number;
  className?: string;
  format: string;
  mask?: string;
  variant?: "primary" | "secondary";
}

export default function AscInputFormat({
  format = "####",
  mask = "_",
  className,
  variant = "primary",
  placeholder,
  ...props
}: AscInputFormatProps) {
  return (
    <PatternFormat
      value={props.value}
      format={format}
      mask={mask}
      onBlur={props.onBlur}
      onFocus={props.onFocus}
      onChange={props.onChange}
      customInput={AscTextInput}
      className={classNames(styles.ground, className, {
        [styles.primary]: variant === "primary",
        [styles.secondary]: variant === "secondary",
      })}
      innerInputClassName={styles.innerInputClassName}
      placeholder={placeholder}
      id={props.id}
      name={props.name}
      disabled={props.disabled}
      max={props.max}
      min={props.min}
    />
  );
}
